import $api from "@/zapi-frontend/shared/api/axios";
import { TClaimReviewReason } from "../model/types";

type TUpdateClaimReviewInput = {
  claimId: number;
  isReviewed: boolean;
  reviewedReason: TClaimReviewReason | null;
  signal?: AbortSignal;
};

type TUpdateClaimReviewOutput = {
  success: boolean;
};

export async function updateClaimReview({
  claimId,
  isReviewed,
  reviewedReason,
  signal
}: TUpdateClaimReviewInput): Promise<TUpdateClaimReviewOutput> {
  const response = await $api.patch<TUpdateClaimReviewOutput>(
    `/claims/${claimId}/review`,
    {
      isReviewed,
      reviewedReason
    },
    { signal }
  );
  return response.data;
}
